<mat-horizontal-stepper [linear]="isLinear" #stepper>
  <mat-step [stepControl]="stepOneForm">
    <form [formGroup]="stepOneForm">
      <div class="card border-0">
        <div class="card-body">
          <div class="row" style="margin-top:1%">
            <div class="col-md-12" style="font-size: 1.0em; text-align: justify; text-justify: distribute-all-lines">
              <div class="container">
                <div class="row">
                  <div class="col-md-12">
                    <p class="text-center" style="font-size: 1.8em; color: #000000; margin-top: 2%; font-family:Arial, Helvetica, sans-serif; font-weight:bold">
                      <i>Canoga Park Class Action Settlement</i>
                    </p>
                  </div>
                </div>
              </div>
              <div class="container" style="border:1px solid #bebaba">
                <br />
                <div class="text-center" style="font-weight:bold; font-size:1.3em; text-decoration:underline">
                  CLAIM AND RELEASE FORM
                </div>
                <br />
                <div class="panel-heading" style="background-color: #dfdfdf; color: black; text-align:center; font-weight:bold">
                  OWNER MAILING ADDRESS
                </div>
                <br />
                <div class="row">
                  <div class="col-md-12">
                    <div class="form-group">
                      <label class="labelBoldWeight" for="cName">Owner Name:</label>
                      <input type="text" class="form-control" formControlName="cName" autocomplete="no" trim="blur" [ngClass]="{ 'is-invalid': e.cName.errors }" readonly />
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <div class="form-group">
                      <label class="labelBoldWeight" for="cAddress">Owner Address:</label>
                      <input type="text" class="form-control" formControlName="cAddress" autocomplete="no" trim="blur" [ngClass]="{ 'is-invalid': e.cAddress.errors }" readonly />
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-4">
                    <div class="form-group">
                      <label class="labelBoldWeight" for="cCity">Owner City:</label>
                      <input type="text" class="form-control" formControlName="cCity" autocomplete="no" trim="blur" [ngClass]="{ 'is-invalid': e.cCity.errors }" readonly />
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group">
                      <label class="labelBoldWeight" for="cState">Owner State:</label>
                      <input type="text" class="form-control" formControlName="cState" autocomplete="no" trim="blur" [ngClass]="{ 'is-invalid': e.cState.errors }" readonly />
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group">
                      <label class="labelBoldWeight" for="cZip">Owner Zip:</label>
                      <input type="text" class="form-control" formControlName="cZip" autocomplete="no" trim="blur" [ngClass]="{ 'is-invalid': e.cZip.errors }" readonly />
                    </div>
                  </div>
                </div>
                <br />
                <div class="panel-heading" style="background-color: #dfdfdf; color: black; text-align:center; font-weight:bold">
                  COVERED PROPERTY INFORMATION
                </div>
                <br />
                <div class="row">
                  <div class="col-md-12">
                    <div class="form-group">
                      <label class="labelBoldWeight" for="pAddress">Covered Street 1:</label>
                      <input type="text" class="form-control" formControlName="pAddress" autocomplete="no" trim="blur" [ngClass]="{ 'is-invalid': e.pAddress.errors }" readonly />
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-4">
                    <div class="form-group">
                      <label class="labelBoldWeight" for="pCity">Covered City:</label>
                      <input type="text" class="form-control" formControlName="pCity" autocomplete="no" trim="blur" [ngClass]="{ 'is-invalid': e.pCity.errors }" readonly />
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group">
                      <label class="labelBoldWeight" for="pState">Covered State:</label>
                      <input type="text" class="form-control" formControlName="pState" autocomplete="no" trim="blur" [ngClass]="{ 'is-invalid': e.pState.errors }" readonly />
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group">
                      <label class="labelBoldWeight" for="pZip">Covered Zip:</label>
                      <input type="text" class="form-control" formControlName="pZip" autocomplete="no" trim="blur" [ngClass]="{ 'is-invalid': e.pZip.errors }" readonly />
                    </div>
                  </div>
                </div>
                <br /><br />


                <h5 style="font-weight:bold; text-decoration:underline; text-align:center">INSTRUCTIONS</h5><br />

                If you own or owned a single-family home or townhome located within the Class Area shown on the map below
                (i) as of August 11, 2026, or (ii) as of July 1, 2024 and you have since
                sold the home as of August 11, 2026, you may be eligible for a settlement payment in
                <i>Canoga Park Class Action Settlement</i>., Case No. 2:21-cv-03946-HDV-SK, if the Court approves
                the Settlement.<br /><br />

                <b>
                  YOU MUST COMPLETE AND SUBMIT THIS CLAIM AND RELEASE FORM, WITH PROOF OF OWNERSHIP, TO RECEIVE A SETTLEMENT
                  PAYMENT
                </b>.<br /><br />

                The amount of any final payment will depend on the Court’s award of attorneys’ fees and costs, the Court’s
                award of service awards, the costs of settlement administration, the geographic sub-area in which your
                property is located, and the number of Settlement Class Members who submit timely and valid Claim Forms.
                See the Notice for details.<br /><br />

                This Claim and Release Form, together with the required documentation, must be postmarked or received by
                the Class Administrator no later than October 10, 2026. You may also complete and submit this Claim and
                Release Form online at <a href="mailto:www.CanogaParkClassAction.com">www.CanogaParkClassAction.com</a> using the following login information:<br /><br />

                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label class="labelBoldWeight" for="uniqueId"></label>
                      <input type="text" class="form-control" formControlName="uniqueId" autocomplete="no" trim="blur" [ngClass]="{ 'is-invalid': e.uniqueId.errors }" hidden />
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label class="labelBoldWeight" for="pin"></label>
                      <input type="text" class="form-control" formControlName="pin" autocomplete="no" trim="blur" [ngClass]="{ 'is-invalid': e.pin.errors }" hidden />
                    </div>
                  </div>
                </div>
                <br />

                Only Claim Forms submitted directly to the Class Administrator are valid. Claim Forms submitted through a
                third-party claims aggregator will not be accepted. For more information, please visit
                <a href="mailto:www.CanogaParkClassAction.com">www.CanogaParkClassAction.com</a> or call 833-419-5050.
                <br /><br />
                <div class="row">
                  <div class="col-md-12">
                    <img src="../../../assets/Class Area Map.jpg" class="img-responsive" style="width:80%;  display: block; margin: 0 auto;">
                  </div>
                </div>
                <br /><br />
                <div class="row">
                  <div class="col-md-12 text-center">
                    <button class="btn btn-primary" matStepperNext>Enter Online Filing Site</button>
                  </div>
                </div>
                <br />

              </div>
            </div>
            <br />
          </div>
        </div>

        <br /><br />
      </div>

    </form>
  </mat-step>

  <mat-step [stepControl]="stepTwoForm">
    <form [formGroup]="stepTwoForm">
      <!--<ng-template cdkStepLabel>
      <div class="step-bullet"></div>
      <div class="step-title"></div>
      </ng-template>-->
      <div class="card border-0">
        <p class="card-body">
          <div class="container">
            <div class="row">
              <div class="col-md-12">
                <p class="text-center" style="font-size: 1.8em; color: #000000; margin-top: 2%; font-family:Arial, Helvetica, sans-serif; font-weight:bold">
                  <i>Canoga Park Class Action Settlement</i>
                </p>
              </div>
            </div>
          </div>
          <div class="container" style="border:1px solid #bebaba">

            <br />
            <div class="panel-heading" style="background-color: #dfdfdf; color: black; text-align:center; font-weight:bold">
              OWNER MAILING ADDRESS
            </div>
            <br />
            <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <label class="labelBoldWeight" for="cName">Owner Name:</label>
                  <input type="text" class="form-control" formControlName="cName" autocomplete="no" trim="blur" [ngClass]="{ 'is-invalid': f.cName.errors }" readonly />
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <label class="labelBoldWeight" for="cAddress">Owner Address:</label>
                  <input type="text" class="form-control" formControlName="cAddress" autocomplete="no" trim="blur" [ngClass]="{ 'is-invalid': f.cAddress.errors }" readonly />
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-4">
                <div class="form-group">
                  <label class="labelBoldWeight" for="cCity">Owner City:</label>
                  <input type="text" class="form-control" formControlName="cCity" autocomplete="no" trim="blur" [ngClass]="{ 'is-invalid': f.cCity.errors }" readonly />
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <label class="labelBoldWeight" for="cState">Owner State:</label>
                  <input type="text" class="form-control" formControlName="cState" autocomplete="no" trim="blur" [ngClass]="{ 'is-invalid': f.cState.errors }" readonly />
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <label class="labelBoldWeight" for="cZip">Owner Zip:</label>
                  <input type="text" class="form-control" formControlName="cZip" autocomplete="no" trim="blur" [ngClass]="{ 'is-invalid': f.cZip.errors }" readonly />
                </div>
              </div>
            </div>
            <br />
            <div class="panel-heading" style="background-color: #dfdfdf; color: black; text-align:center; font-weight:bold">
              COVERED PROPERTY INFORMATION
            </div>
            <br />
            <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <label class="labelBoldWeight" for="pAddress">Covered Street 1:</label>
                  <input type="text" class="form-control" formControlName="pAddress" autocomplete="no" trim="blur" [ngClass]="{ 'is-invalid': f.pAddress.errors }" readonly />
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-4">
                <div class="form-group">
                  <label class="labelBoldWeight" for="pCity">Covered City:</label>
                  <input type="text" class="form-control" formControlName="pCity" autocomplete="no" trim="blur" [ngClass]="{ 'is-invalid': f.pCity.errors }" readonly />
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <label class="labelBoldWeight" for="pState">Covered State:</label>
                  <input type="text" class="form-control" formControlName="pState" autocomplete="no" trim="blur" [ngClass]="{ 'is-invalid': f.pState.errors }" readonly />
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <label class="labelBoldWeight" for="pZip">Covered Zip:</label>
                  <input type="text" class="form-control" formControlName="pZip" autocomplete="no" trim="blur" [ngClass]="{ 'is-invalid': f.pZip.errors }" readonly />
                </div>
              </div>
            </div>
            <br /><br />
            <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <label class="labelBoldWeight" for="informationUpdated">Do you need to update your mailing address?:</label>
                  <select class="form-control" formControlName="informationUpdated" (change)="getInformationUpdatedValue($event)" [ngClass]="{ 'is-invalid': f.informationUpdated.errors }">
                    <option value="">Please select an option</option>
                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                  </select>
                  <div *ngIf="f.informationUpdated.errors" class="invalid-feedback">
                    <div *ngIf="f.informationUpdated.errors.required">This field is required</div>
                  </div>
                </div>
              </div>
            </div>
            <div *ngIf="showDivPaymentEmail == true">

              <p class="text-center" style="font-weight:bold; font-size:1.4em">
                UPDATE MAILING ADDRESS INFORMATION
              </p>
              <br />
              <div class="panel-heading" style="background-color: #dfdfdf; color: black; text-align:center">
                <b>NAME SECTION</b>
              </div>
              <br />
              <div style="font-size: 1.0em;">
                <div class="row">
                  <div class="col-md-12">
                    <div class="form-group">
                      <label class="labelBoldWeight" for="cName">Owner Name:</label>
                      <input type="text" class="form-control" formControlName="cName" autocomplete="no" trim="blur" [ngClass]="{ 'is-invalid': e.cName.errors }" readonly />
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12" style="font-weight:bold; color:red; text-align:center">
                    To update the name on your claim, please contact the Class Administrator at <a href="mailto:info@CanogaParkClassAction.com">info@CanogaParkClassAction.com</a> or 833-419-5050.
                  </div>
                </div>
                <br />
                <br />
                <div class="panel-heading" style="background-color: #dfdfdf; color: black; text-align:center">
                  <b>ADDRESS SECTION</b>
                </div>
                <br />
                <div class="row rowformat">
                  <div class="col-md-12">
                    <div class="form-group">
                      <label class="labelBoldWeight" for="updatedContactStreet1">Address 1 (street name and number):<span style="color:red" class="required"> *</span></label>
                      <input type="text" class="form-control" formControlName="updatedContactStreet1" autocomplete="no" trim="blur" [ngClass]="{ 'is-invalid': f.updatedContactStreet1.errors }" />
                      <div *ngIf="f.updatedContactStreet1.errors" class="invalid-feedback">
                        <div *ngIf="f.updatedContactStreet1.errors.required">This field is required</div>
                        <div *ngIf="f.updatedContactStreet1.errors.minlength">This field must be at least 2 characters</div>
                        <div *ngIf="f.updatedContactStreet1.errors.maxlength">This field must not be at greater 50 characters</div>
                        <div *ngIf="f.updatedContactStreet1.errors.pattern">
                          Only use letters, numbers, periods, spaces, hyphens, brackets, ampersands, apostophes, parentheses slash(/), pound sign(#)
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row rowformat">
                  <div class="col-md-12">
                    <div class="form-group">
                      <label class="labelBoldWeight" for="updatedContactStreet2">Address 2 (apartment, unit, or box number):</label>
                      <input type="text" class="form-control" formControlName="updatedContactStreet2" autocomplete="no" trim="blur" [ngClass]="{ 'is-invalid': f.updatedContactStreet2.errors }" />
                      <div *ngIf="f.updatedContactStreet2.errors" class="invalid-feedback">
                        <div *ngIf="f.updatedContactStreet2.errors.required">This field is required</div>
                        <div *ngIf="f.updatedContactStreet2.errors.minlength">This field must be at least 2 characters</div>
                        <div *ngIf="f.updatedContactStreet2.errors.maxlength">This field must not be greater than 50 characters</div>
                        <div *ngIf="f.updatedContactStreet2.errors.pattern">
                          Only use letters, numbers, periods, spaces, hyphens, brackets, ampersands, apostophes, parentheses slash(/), pound sign(#)
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row rowformat">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label class="labelBoldWeight" for="updatedContactCountry">Country:<span style="color:red" class="required"> *</span></label>
                      <select class="form-control" formControlName="updatedContactCountry" (change)="getCountryValue($event)" [ngClass]="{ 'is-invalid': f.updatedContactCountry.errors }">
                        <option value="">Please Select A Country</option>
                        <option *ngFor="let allcountry of allCountries">
                          {{allcountry.Name}}
                        </option>
                      </select>
                      <div *ngIf="f.updatedContactCountry.errors" class="invalid-feedback">
                        <div *ngIf="f.updatedContactCountry.errors.required">This field is required</div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label class="labelBoldWeight" for="updatedContactCity">City:<span style="color:red" class="required"> *</span></label>
                      <input type="text" class="form-control" formControlName="updatedContactCity" autocomplete="no" trim="blur" [ngClass]="{ 'is-invalid': f.updatedContactCity.errors }" />
                      <div *ngIf="f.updatedContactCity.errors" class="invalid-feedback">
                        <div *ngIf="f.updatedContactCity.errors.required">This field is required</div>
                        <div *ngIf="f.updatedContactCity.errors.minlength">This field must be at least 2 characters</div>
                        <div *ngIf="f.updatedContactCity.errors.maxlength">This field must not be greater than 40 characters</div>
                        <div *ngIf="f.updatedContactCity.errors.pattern">
                          Only use letters, numbers, periods, spaces, hyphens, brackets, ampersands, apostophes, parentheses slash(/), pound sign(#)
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div *ngIf="showDivForNonUS">
                  <div class="row rowformat">
                    <div class="col-md-12">
                      <div class="form-group">
                        <label class="labelBoldWeight" for="updatedContactProvince">Province:<span style="color:red" class="required"> *</span></label>
                        <input type="text" class="form-control" formControlName="updatedContactProvince" autocomplete="no" trim="blur" [ngClass]="{ 'is-invalid': f.updatedContactProvince.errors }" />
                        <div *ngIf="f.updatedContactProvince.errors" class="invalid-feedback">
                          <div *ngIf="f.updatedContactProvince.errors.required">This field is required</div>
                          <div *ngIf="f.updatedContactProvince.errors.minlength">This field must be at least 2 characters</div>
                          <div *ngIf="f.updatedContactProvince.errors.maxlength">This field must not be greater than 40 characters</div>
                          <div *ngIf="f.updatedContactProvince.errors.pattern">
                            Only use letters, numbers, periods, spaces, hyphens, brackets, ampersands, apostophes, parentheses slash(/), pound sign(#)
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row rowformat">
                    <div class="col-md-12">
                      <div class="form-group">
                        <label class="labelBoldWeight" for="updatedContactPostalCode">Postal Code:</label>
                        <input type="text" class="form-control" formControlName="updatedContactPostalCode" autocomplete="no" trim="blur" [ngClass]="{ 'is-invalid': f.updatedContactPostalCode.errors }" />
                        <div *ngIf="f.updatedContactPostalCode.errors" class="invalid-feedback">
                          <div *ngIf="f.updatedContactPostalCode.errors.maxlength">This field must not be greater than 10 characters</div>
                          <div *ngIf="f.updatedContactPostalCode.errors.pattern">
                            Only use letters, numbers, periods, spaces, hyphens, brackets, ampersands, apostophes, parentheses slash(/), pound sign(#)
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div *ngIf="showDivForUS">
                  <div class="row rowformat">
                    <div class="col-md-6">
                      <div class="form-group">
                        <label class="labelBoldWeight" for="updatedContactState">State:<span style="color:red" class="required"> *</span></label>
                        <select class="form-control" formControlName="updatedContactState" [ngClass]="{ 'is-invalid': f.updatedContactState.errors }">
                          <option value="">Please Select A State</option>
                          <option *ngFor="let allstate of allStates">
                            {{allstate.Name}}
                          </option>
                        </select>
                        <div *ngIf="f.updatedContactState.errors" class="invalid-feedback">
                          <div *ngIf="f.updatedContactState.errors.required">This field is required</div>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label class="labelBoldWeight" for="updatedContactZip">Zip Code:<span style="color:red" class="required"> *</span></label>
                        <input type="text" class="form-control" formControlName="updatedContactZip" autocomplete="no" trim="blur" [ngClass]="{ 'is-invalid': f.updatedContactZip.errors }" />
                        <div *ngIf="f.updatedContactZip.errors" class="invalid-feedback">
                          <div *ngIf="f.updatedContactZip.errors.required">This field is required</div>
                          <div *ngIf="f.updatedContactZip.errors.pattern">
                            US zip Code with format 99999 or 99999-9999 alone are accepted
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
            <br />  <div class="panel-heading" style="background-color: #dfdfdf; color: black; text-align:center">
              <b>CONTACT AND ACCOUNT SECTION</b>
            </div>
            <br />

            <div class="row rowformat">
              <div class="col-md-6">
                <div class="form-group">
                  <label class="labelBoldWeight" for="primaryPhone">Primary Phone Number:<span style="color:red" class="required"> *</span></label>
                  <input type="text" mask="(000) 000-0000" [showMaskTyped]="true" class="form-control" formControlName="primaryPhone" placeholder="XXX-XXX-XXXX (No dashes)" autocomplete="no" trim="blur"
                         [ngClass]="{ 'is-invalid': f.primaryPhone.errors }" />
                  <div *ngIf="f.primaryPhone.errors" class="invalid-feedback">
                    <div *ngIf="f.primaryPhone.errors.required">This field is required</div>
                    <div *ngIf="f.primaryPhone.errors.minlength">This field must be at least 10 digits</div>
                    <div *ngIf="f.primaryPhone.errors.maxlength">This field must not be greater than 10 digits</div>
                    <div *ngIf="f.primaryPhone.errors.pattern">Only use numbers</div>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label class="labelBoldWeight" for="primaryPhoneType">Primary Phone Type:<span style="color:red" class="required"> *</span></label>
                  <select class="form-control" formControlName="primaryPhoneType" [ngClass]="{ 'is-invalid': f.primaryPhoneType.errors }">
                    <option value="">Please Select Phone Type</option>
                    <option value="Cell">Mobile</option>
                    <option value="Land">Landline</option>
                  </select>
                  <div *ngIf="f.primaryPhoneType.errors" class="invalid-feedback">
                    <div *ngIf="f.primaryPhoneType.errors.required">This field is required</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row rowformat">
              <div class="col-md-12">
                <div class="form-group">
                  <label class="labelBoldWeight" for="emailAddress">Email Address:<span style="color:red" class="required"> *</span></label>
                  <input type="text" class="form-control" formControlName="emailAddress" autocomplete="no" trim="blur" [ngClass]="{ 'is-invalid': f.emailAddress.errors }" />
                  <div *ngIf="f.emailAddress.errors" class="invalid-feedback">
                    <div *ngIf="f.emailAddress.errors.required">This field is required</div>
                    <div *ngIf="f.emailAddress.errors.maxlength">This field must not be greater than 255 characters</div>
                    <div *ngIf="f.emailAddress.errors.pattern">This is not a valid email address</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row rowformat">
              <div class="col-md-6">
                <span class="labelBoldWeight">Select an Option Below:<span style="color:red" class="required"> *</span></span><br />
                <input type="radio" id="lastFourOfSSN" formControlName="optTINSSN" (change)="getOptTINSSNValue($event)" value="Last Four Of SSN">&nbsp;
                <label for="lastFourOfSSN">Social Security Number</label>
                &nbsp;
                <input type="radio" id="taxIdentificationNumber" formControlName="optTINSSN" (change)="getOptTINSSNValue($event) " value="Tax Identification Number">&nbsp;
                <label for="taxIdentificationNumber"> Tax Identification Number</label>
                <div *ngIf="f.optTINSSN.errors" class="custom-error-original">
                  <div *ngIf="f.optTINSSN.errors.required">This field is required</div>
                </div>
              </div>
            </div>
            <div class="row rowformat">
              <div class="col-md-6">
                <div class="form-group" *ngIf="showDivlast4SSN">
                  <label class="labelBoldWeight" for="sSN">Social Security Number:<span style="color:red" class="required"> *</span></label>
                  <input type="text" mask="XXX-XX-0000" class="form-control" [hiddenInput]="true" formControlName="sSN" autocomplete="no" trim="blur" [ngClass]="{ 'is-invalid': f.sSN.errors }" />
                  <div *ngIf="f.sSN.errors" class="invalid-feedback">
                    <div *ngIf="f.sSN.errors.required">This field is required</div>
                    <div *ngIf="f.sSN.errors.minlength">This field must be at least 9 digits</div>
                    <div *ngIf="f.sSN.errors.maxlength">This field must not be greater than 9 digits</div>
                    <div *ngIf="f.sSN.errors.pattern">
                      Only use letters numbers
                    </div>
                  </div>
                </div>
                <div class="form-group" *ngIf="showDivTIN">
                  <label class="labelBoldWeight" for="tin">Tax Identification Number:<span style="color:red" class="required"> *</span></label>
                  <input type="text" mask="000000000" class="form-control" formControlName="tin" autocomplete="no" trim="blur" [ngClass]="{ 'is-invalid': f.tin.errors }" />
                  <div *ngIf="f.tin.errors" class="invalid-feedback">
                    <div *ngIf="f.tin.errors.required">This field is required</div>
                    <div *ngIf="f.tin.errors.minlength">This field must be at least 9 digits</div>
                    <div *ngIf="f.tin.errors.maxlength">This field must not be greater than 9 digits</div>
                    <div *ngIf="f.tin.errors.pattern">
                      Only use letters numbers
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <br />
            <ul class="list-inline float-right">
              <li>
                <button class="btn btn-primary" matStepperPrevious>Back</button>&nbsp;
                <button class="btn btn-primary" (click)="saveAndValidateStepTwo()">Next</button>
              </li>
            </ul>
          </div>
      </div>
    </form>
  </mat-step>

  <mat-step [stepControl]="stepThreeForm">
    <form [formGroup]="stepThreeForm">
      <!--<ng-template cdkStepLabel>
      <div class="step-bullet"></div>
      <div class="step-title"></div>
      </ng-template>-->
      <div class="card border-0">
        <div class="card-body">
          <br />
          <div class="text-center" style="font-weight:bold; font-size:1.3em; text-decoration:underline">
            PROPERTY OWNERSHIP INFORMATION
          </div>
          <div class="row">
            <div class="col-md-12">

              If you own or owned more than one single-family home or townhome in the Class Area, please complete a separate Claim Form for
              each property. Additional Claim Forms are available at <a href="mailto:www.CanogaParkClassAction.com">www.CanogaParkClassAction.com</a> or by calling 833-419-5050.
            </div>
          </div>
          <br />
          <div class="panel-heading" style="background-color: #dfdfdf; color: black; text-align:center; font-weight:bold">
            ADDRESS OF ELIGIBLE PROPERTY IN CLASS AREA
          </div>
          <br />
          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <label class="labelBoldWeight" for="pAddress">Covered Street 1:</label>
                <input type="text" class="form-control" formControlName="pAddress" autocomplete="no" trim="blur" [ngClass]="{ 'is-invalid': e.pAddress.errors }" readonly />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4">
              <div class="form-group">
                <label class="labelBoldWeight" for="pCity">Covered City:</label>
                <input type="text" class="form-control" formControlName="pCity" autocomplete="no" trim="blur" [ngClass]="{ 'is-invalid': e.pCity.errors }" readonly />
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label class="labelBoldWeight" for="pState">Covered State:</label>
                <input type="text" class="form-control" formControlName="pState" autocomplete="no" trim="blur" [ngClass]="{ 'is-invalid': e.pState.errors }" readonly />
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label class="labelBoldWeight" for="pZip">Covered Zip:</label>
                <input type="text" class="form-control" formControlName="pZip" autocomplete="no" trim="blur" [ngClass]="{ 'is-invalid': e.pZip.errors }" readonly />
              </div>
            </div>
          </div>
          <br />
          <div class="panel-heading" style="background-color: #dfdfdf; color: black; text-align:center; font-weight:bold">
            PERIOD OF OWNERSHIP
          </div>
          <br />
          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <label class="titleBold" for="dateTitleAcquired">
                  1. When did you purchase or otherwise acquire title to the Property?:
                  <span style="color:red; font-weight:bold" class="required"> *This Field is Required</span>
                </label>
                <input type="text" class="form-control" formControlName="dateTitleAcquired" onkeydown="event.preventDefault()" bsDatepicker [bsConfig]="purchasesDatePickerConfig"
                       [ngClass]="{ 'is-invalid': g.dateTitleAcquired.errors }" />
                <div *ngIf="g.dateTitleAcquired.errors" class="invalid-feedback">
                  <div *ngIf="g.dateTitleAcquired.errors.required">This field is required</div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <label class="titleBold" for="didYouOwnPropertyDuringClassPeriod">2. Did you own the Property as of July 1, 2024?:<span style="color:red; font-weight:bold" class="required"> *This Field is Required</span></label>
                <select class="form-control" formControlName="didYouOwnPropertyDuringClassPeriod" [ngClass]="{ 'is-invalid': g.didYouOwnPropertyDuringClassPeriod.errors }">
                  <option value="">Please Select an Option</option>
                  <option value="Yes">Yes</option>
                  <option value="No">No</option>
                </select>
                <div *ngIf="g.didYouOwnPropertyDuringClassPeriod.errors" class="invalid-feedback">
                  <div *ngIf="g.didYouOwnPropertyDuringClassPeriod.errors.required">This field is required</div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <label for="doYouCurrentlyOwnTheProperty"><b>3. Do you currently own the Property?:</b><span style="color:red; font-weight:bold" class="required"> *This Field is Required</span></label>
                <select class="form-control" formControlName="doYouCurrentlyOwnTheProperty" (change)="getOwnedPropertyValue($event)" [ngClass]="{ 'is-invalid': g.doYouCurrentlyOwnTheProperty.errors }">
                  <option value="">Please Select an Option</option>
                  <option value="Yes">Yes</option>
                  <option value="No">No</option>
                </select>
                <div *ngIf="g.doYouCurrentlyOwnTheProperty.errors" class="invalid-feedback">
                  <div *ngIf="g.doYouCurrentlyOwnTheProperty.errors.required">This field is required</div>
                </div>
              </div>
            </div>
          </div>
          <div class="row" *ngIf="showDivOwnedProperty">
            <div class="col-md-12">
              <div class="form-group">
                <label class="titleBold" for="datePropertyWasSoldOrTransferred">
                  4. If you answered “No” to Question 3, when did you sell or otherwise transfer your interest in the Property?:<span style="color:red; font-weight:bold" class="required"> *This Field is Required</span>
                </label>
                <input type="text" class="form-control" formControlName="datePropertyWasSoldOrTransferred" onkeydown="event.preventDefault()" bsDatepicker [bsConfig]="purchasesDatePickerConfig"
                       [ngClass]="{ 'is-invalid': clicked && g.datePropertyWasSoldOrTransferred.errors }" />
                <div *ngIf="clicked && g.datePropertyWasSoldOrTransferred.errors" class="invalid-feedback">
                  <div *ngIf="g.datePropertyWasSoldOrTransferred.errors.required">This field is required</div>
                  <div *ngIf="stepThreeForm.get('datePropertyWasSoldOrTransferred')?.hasError('buttonNotClicked') && stepThreeForm.get('datePropertyWasSoldOrTransferred')?.dirty">
                    Remember to click the Add Button!
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <label for="isThereACoOwner"><b>5. Did you or do you currently own the Property with anyone else (for example, a spouse or co-owner)?:</b><span style="color:red; font-weight:bold" class="required"> *This Field is Required</span></label>
                <select class="form-control" formControlName="isThereACoOwner" (change)="getCoOwnerValue($event)" [ngClass]="{ 'is-invalid': g.isThereACoOwner.errors }">
                  <option value="">Please Select an Option</option>
                  <option value="Yes">Yes</option>
                  <option value="No">No</option>
                </select>
                <div *ngIf="g.isThereACoOwner.errors" class="invalid-feedback">
                  <div *ngIf="g.isThereACoOwner.errors.required">This field is required</div>
                </div>
              </div>
            </div>
          </div>
          <div class="row" *ngIf="showDivCoOwners">
            <div class="col-md-12">
              <b>6. If you answered “Yes” to Question 5, please list all other co-owners of the Property (each co-owner must either complete his or her own Claim and Release Form or sign this Claim and Release Form below):</b><span style="color:red" class="required"> *</span><br /><br />
              <div class="card card-body bg-light mt-3">
                <div class="card-header bg-primary text-white">
                  Add Co-Owners
                </div>
                <br />
                <div class="row mb-3">
                  <div class="col-md-12">
                    <div class="row">
                      <div class="col-md-12">
                        <div class="form-group">
                          <label class="titleBold" for="coOwnerName">
                            Co-Owner's Name
                          </label>
                          <input type="text" class="form-control" formControlName="coOwnerName" autocomplete="no" trim="blur"
                                 [ngClass]="{ 'is-invalid': g.coOwnerName.errors }" />
                          <div *ngIf="g.coOwnerName.errors" class="invalid-feedback">
                            <div *ngIf="g.coOwnerName.errors.required">This field is required</div>
                            <div *ngIf="g.coOwnerName.errors.maxlength">This field cannot be more than 50 characters</div>
                            <div *ngIf="g.coOwnerName.errors.minlength">This field cannot be less than 2 characters</div>
                            <div *ngIf="g.coOwnerName.errors.pattern">
                              Only use letters, numbers, periods, spaces, hyphens, brackets, ampersands, apostophes, parentheses slash(/), pound sign(#)
                            </div>
                          </div>

                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-6">
                        <button type="button" (click)="addCoOwnerData()" class="btn btn-success">Add Co-Owner's Name</button>&nbsp;
                        <button type="button" (click)="clearCoOwnerData()" class="btn btn-danger btn-sm">Clear Co-Owner's Name</button>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-sm-12 table-responsive">
                    <table class="table" #listofFiles>
                      <thead>
                        <tr>
                          <th class="tableHeaderFormattedText">Co-Owner's Name</th>
                          <th class="tableHeaderFormattedText">Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let nL of coOwnerNameList; let i = index">
                          <td class="hidden">{{i}}</td>
                          <td class="tableRowFormattedText">{{nL.CoOwnerName}}</td>
                          <td>
                            <button type="button" class="btn btn-danger"
                                    (click)="removecoOwnerNamesRow(i)">
                              Remove
                            </button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <br /><br />
                <div class="row">
                  <div class="col-md-12 text-center">
                    <div *ngIf="showMessage == true" class="submittal-custom-error" style="color:red">
                      Please click the "Add" button before moving to the next step.
                    </div>
                  </div>
                </div>
          <br /><br />
          <br />
          <ul class="list-inline float-right">
            <li>
              <button class="btn btn-primary" matStepperPrevious>Back</button>&nbsp;
              <button class="btn btn-primary" (click)="saveAndValidateStepThree()">Next</button>
            </li>
          </ul>
        </div>
      </div>
    </form>
  </mat-step>
  <mat-step [stepControl]="stepFourForm">
    <form [formGroup]="stepFourForm">
      <div class="card border-0">

        <div class="card-body">
          <br />
          <div class="row lightgraybackground">
            <div class="col-md-12 text-center">
              EMPLOYEE VERIFICATION
            </div>
          </div>
          <br />
          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <label for="areYouAnEmployee"><b>Are you an employee of Northrop Grumman Corporation or Northrop Grumman Systems Corporation?:</b><span style="color:red; font-weight:bold" class="required"> *This Field is Required</span></label>
                <select class="form-control" formControlName="areYouAnEmployee" (change)="getPaymentRadioValue($event)" [ngClass]="{ 'is-invalid': h.areYouAnEmployee.errors }">
                  <option value="">Please Select an Option</option>
                  <option value="Yes">Yes</option>
                  <option value="No">No</option>
                </select>
                <div *ngIf="h.areYouAnEmployee.errors" class="invalid-feedback">
                  <div *ngIf="h.areYouAnEmployee.errors.required">This field is required</div>
                </div>
              </div>
            </div>
          </div>
          <div class="row" *ngIf="showDivACH">
            <div class="col-md-12">
              By checking the box below, I verify under penalty of perjury that I am not an employee of Northrop Grumman Corporation or Northrop Grumman Systems Corporation. Employees of Defendants are excluded from the Settlement Class and are not eligible to participate in the Settlement.<br /><br />
              <div class="form-group form-check">
                <input type="checkbox" formControlName="verifyNonEmployment" class="form-check-input" [ngClass]="{ 'is-invalid': h.verifyNonEmployment.errors }" />                <label for="verifyNonEmployment">
                  <b>
                    I verify that I am not an employee of Northrop Grumman Corporation or Northrop Grumman Systems Corporation.
                  </b><span style="font-weight:bold;color:red" class="required"> *</span>
                </label>
                <div *ngIf="h.verifyNonEmployment.errors" class="invalid-feedback">
                  <div *ngIf="h.verifyNonEmployment.errors.required">This field is required</div>
                </div>
              </div>
            </div>
          </div>
          <div>
          </div>

          <br />
          <ul class="list-inline float-right">
            <li>
              <button type="button" class="btn btn-primary" matStepperPrevious>Back</button>&nbsp;
              <button type="button" class="btn btn-primary" (click)="saveAndValidateStepFour()">Next</button>
            </li>
          </ul>

        </div>
      </div>
    </form>
  </mat-step>
  <mat-step [stepControl]="stepFiveForm">
    <form [formGroup]="stepFiveForm">
      <!--<ng-template cdkStepLabel>
    <div class="step-bullet"></div>
    <div class="step-title"></div>
    </ng-template>-->
      <br />
      <div class="row lightgraybackground">
        <div class="col-md-12 text-center">
          PROOF OF OWNERSHIP
        </div>
      </div>
      <br />
      <div class="row">
        <div class="col-md-12">
          Attach documentary proof of ownership of the Property showing that you owned the Property either as of July 1, 2024 or as of August 11, 2026. The following types of documents are acceptable proof of ownership. Please attach a copy of one of the following documents and select the corresponding Documentation Type.<br /><br />
          <b>If you did not upload documentation, please select that option below</b><br/>
          Property deed<br />
          Title insurance policy<br />
          Mortgage statement<br />
          Property tax statement or bill<br />
          Settlement / closing statement (e.g., HUD-1, Closing Disclosure)<br />
          Homeowners insurance policy declaration page<br />
          Certificate of title<br />
          Government record evidencing ownership<br />
          Utility bill (water, electric, gas, sewer, or trash) listing the Settlement Class Member’s name and the address of the property in the Class Area<br /><br />
        </div>
    </div>
    <div class="row rowformat">
      <div class="col-md-6">
        <div class="form-group">
          <label class="labelBoldWeight" for="documentType">Documentation Type:<span style="color:red" class="required"> *</span></label>
          <select class="form-control" formControlName="documentType" (change)="getClaimantAccounTypeValue($event)" [ngClass]="{ 'is-invalid': i.documentType.errors }">
            <option value="">Please Select an Option</option>
            <option value="Documentation was not uploaded">Documentation was not uploaded</option>
            <option value="Property deed">Property deed</option>
            <option value="Title insurance policy">Title insurance policy</option>
            <option value="Mortgage statement">Mortgage statement</option>
            <option value="Property tax statement or bill">Property tax statement or bill</option>
            <option value="Settlement or closing statement">Settlement / closing statement (e.g., HUD-1, Closing Disclosure)</option>
            <option value="Homeowners insurance policy declaration page">Homeowners insurance policy declaration page</option>
            <option value="Certificate of title">Certificate of title</option>
            <option value="Government record evidencing ownership">Government record evidencing ownership</option>
            <option value="Utility bill">Utility bill (water, electric, gas, sewer, or trash) listing the Settlement Class Member’s name and the address of the property in the Class Area</option>
            <option value="Other">Other (please describe)</option>
          </select>
          <div *ngIf="i.documentType.errors" class="invalid-feedback">
            <div *ngIf="i.documentType.errors.required">This field is required</div>
          </div>
        </div>
      </div>
      <div class="col-md-6" *ngIf="showDivOtherDocumentType">
        <div class="form-group">
          <label class="labelBoldWeight" for="otherDocumentType">Other (please describe):<span style="color:red" class="required"> *</span></label>
          <input type="text" class="form-control" formControlName="otherDocumentType" autocomplete="no" trim="blur" [ngClass]="{ 'is-invalid': i.otherDocumentType.errors }" />
          <div *ngIf="i.otherDocumentType.errors" class="invalid-feedback">
            <div *ngIf="i.otherDocumentType.errors.required">This field is required</div>
            <div *ngIf="i.otherDocumentType.errors.minlength">This field must be at least 2 characters</div>
            <div *ngIf="i.otherDocumentType.errors.maxlength">This field must not be greater than 50 characters</div>
            <div *ngIf="i.otherDocumentType.errors.pattern">
              Only use letters, numbers, periods, spaces, hyphens, brackets, ampersands, apostophes, parentheses slash(/), pound sign(#)
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card border-0">
      <div class="card-body">
        <div class="text-center" style="margin-top:1%; font-weight:bold; font-size:1.4em; text-decoration:underline">
          Upload Documents
        </div>
        <br />
        <div style="font-size: 1.0em;">

          <div class="row">
            <div class="col-md-12">
              Please submit legible copies of supporting documentation. Do not send originals, but maintain the originals in your records. Claimants may be
              requested to furnish additional information regarding this Claim Form that the Claims Administrator, Class Counsel, or the Court may require.
            </div>
          </div>
          <div class="row mt-4">
            <div class="col-md-12">
              <input type="file" id="file" #fileInput (change)="getFileDetails($event)" multiple class="form-control form-control-sm hidden" />
              <label for="file" class="btn btn-primary btn-sm">Documents To Upload</label>
              <br />
            </div>
          </div>
          <br />
          <div class="row">
            <div class="col-sm-12">
              <table class="table" #listofFiles>
                <thead>
                  <tr>
                    <th class="hidden">Id</th>
                    <th>Files To Be Uploaded</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let sd of supportingDocuments; let i = index">
                    <td class="hidden">{{i}}</td>
                    <td>{{sd.name}}</td>
                    <td>
                      <button type="button" class="btn btn-danger" (click)="removeRow(i)">Remove</button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <br />
          <div class="row" *ngIf="showDivNoDocsMessage">
            <div class="col-md-12">
              You must upload a document
            </div>
          </div>
          <br />
          <ul class="list-inline float-right">
            <li>
              <button class="btn btn-primary" matStepperPrevious>Back</button>&nbsp;
              <button class="btn btn-primary" (click)="saveAndValidateStepFive()">Next</button>
            </li>
          </ul>
        </div>
      </div>
    </div>
    </form>
  </mat-step>

  <mat-step [stepControl]="stepSixForm">
    <form [formGroup]="stepSixForm">
      <!--<ng-template cdkStepLabel>
      <div class="step-bullet"></div>
      <div class="step-title"></div>
      </ng-template>-->
      <div class="card border-0">
        <div class="card-body">
          <div class="container">
            <div class="row">
              <div class="col-md-12">
                <p class="text-center" style="font-size: 1.8em; color: #000000; margin-top: 2%; font-family:Arial, Helvetica, sans-serif; font-weight:bold">
                  Canoga Park Class Action
                </p>
              </div>
            </div>
          </div>
          <div class="container" style="border:1px solid #bebaba">
            <div class="text-center" style="margin-top:1%; font-weight:bold; font-size:1.4em; text-decoration:underline">
              CERTIFICATION AND RELEASE OF CLAIMS
            </div>
            <br />
            <div class="row">
              <div class="col-md-12" style="font-size: 1.0em; text-align: justify; text-justify: distribute-all-lines">
                Read this Section carefully. By signing below, you are agreeing to release legal claims you may have against the Released Parties.<br /><br />

                <b>Certification.</b><br /><br />

                I hereby certify, under penalty of perjury under the laws of the United States, that: (1) the foregoing information is true and correct to
                the best of my knowledge; (2) I am not an employee of Defendants; and (3) I either currently own, or owned as of July 1, 2024 (and have
                since sold), the single-family home or townhome at the address located within the Class Area.<br /><br />

                <b>Released Parties.</b><br /><br />

                “Released Parties” shall mean Defendants Northrop Grumman Corporation and Northrop Grumman Systems Corporation, including each of their past
                and present successors, subsidiaries, parents, holding companies, sister and affiliated companies, divisions and other related entities, as
                well as the successors, predecessors, shareholders, subsidiaries, investors, parent, sister and affiliated companies, including but not
                limited to Northrop Grumman Guidance and Electronics Company, Inc., officers, directors, partners, assigns, agents, employees, principals,
                heirs, administrators, attorneys, vendors, accountants, auditors, consultants, fiduciaries, insurers, reinsurers, employee benefit plans,
                and representatives of each of them, both individually and in their official capacities, past or present, as well as all persons acting by,
                through, under, or in concert with, any of these persons or entities.<br /><br />

                <b>Release of Claims.</b><br /><br />

                In exchange for, and upon receipt of, the settlement payment for which I am submitting this Claim and Release Form, and as a Settlement
                Class Member who has not opted out of the Settlement, I (on behalf of myself and my heirs, executors, administrators, successors, and
                assigns) hereby fully release and forever discharge the Released Parties from any and all claims, judgments, liens, losses, debts,
                liabilities, demands, obligations, guarantees, penalties, costs, expenses, attorneys’ fees, damages, indemnities, actions, causes of
                action, and obligations of every kind and nature, in law, equity, or otherwise, known or unknown, suspected or unsuspected, foreseen
                or unforeseen, developed or undeveloped, disclosed or undisclosed, contingent or accrued, liquidated or unliquidated, arising under
                common law, regulatory law, statutory law, or otherwise, whether based on federal, state or local law, statute, ordinance, regulation,
                code, contract, common law, or any other source, that I ever had, now have, may have, or hereafter can, shall, or may ever have against
                the Released Parties for property damage or Mitigation Measures that arise out of or relate to the facts alleged in the Second Amended
                Complaint (Dkt. 91) or Section VII of the Proposed Final Pretrial Conference Order (Dkt. 348-1 at 10–20) (the “Released Claims”).<br /><br />

                The Released Claims include any unknown claims for property damage or Mitigation Measures that I do not know or suspect to exist in my
                favor, which, if known by me, might have affected this release. The Released Claims do NOT include claims for personal injury, wrongful
                death, or claims for medical monitoring.<br /><br />

                <b>Waiver of California Civil Code Section 1542.</b><br /><br />

                I expressly, knowingly, and voluntarily waive the provisions of California Civil Code section 1542, and any similar law of any other
                state or jurisdiction, which provides:<br /><br />

                                                            <b>
                                                              A GENERAL RELEASE DOES NOT EXTEND TO CLAIMS THAT THE CREDITOR OR RELEASING PARTY DOES NOT KNOW OR SUSPECT TO EXIST IN HIS OR HER FAVOR
                                                              AT THE TIME OF EXECUTING THE RELEASE AND THAT, IF KNOWN BY HIM OR HER, WOULD HAVE MATERIALLY AFFECTED HIS OR HER SETTLEMENT WITH THE
                                                              DEBTOR OR RELEASED PARTY
                                                            </b>.<br /><br />

                I acknowledge that I am aware that I or my attorneys may hereafter discover claims or facts in addition to or different from those I
                now know or believe exist with respect to the Released Claims, but it is my intention to fully, finally, and forever settle and release
                all of the Released Claims, known or unknown, suspected or unsuspected, asserted or unasserted, or past, present or future, that I have
                against the Released Parties. I have had the opportunity to seek the advice of counsel regarding the contents and effect of section 1542.<br /><br />

                <b>No Assignment.</b><br /><br />

                I represent and warrant that I have not assigned, sold, or otherwise transferred any portion of the Released Claims to any other person or entity.
              </div>
            </div>
            <div class="text-center" style="margin-top:1%; font-weight:bold; font-size:1.4em; text-decoration:underline">
              SIGN AND DATE
            </div>
            <br />
            <div class="row">
              <div class="col-md-12" style="font-size: 1.0em; text-align: justify; text-justify: distribute-all-lines">
                You must sign this Claim and Release Form under penalty of perjury. Please make sure all information is true and correct before signing.<br /><br />
              </div>
            </div>
            <div style="font-size: 1.0em;">
              <div class="row rowformat">
                <div class="col-md-12">
                  <div class="form-group">
                    <label for="propertyOwnerSignature"><b>Property Owner’s Signature:</b><span style="color:red" class="required"> *</span></label>
                    <input type="text" class="form-control" id="propertyOwnerSignature" formControlName="propertyOwnerSignature" autocomplete="no"
                           trim="blur" [ngClass]="{ 'is-invalid': j.propertyOwnerSignature.errors }" />
                    <div *ngIf="j.propertyOwnerSignature.errors" class="invalid-feedback">
                      <div *ngIf="j.propertyOwnerSignature.errors.required">This field is required</div>
                      <div *ngIf="j.propertyOwnerSignature.errors.maxlength">This field must not be greater than 50 characters</div>
                      <div *ngIf="j.propertyOwnerSignature.errors.minlength">This field must be at least 2 characters</div>
                      <div *ngIf="j.propertyOwnerSignature.errors.pattern">
                        Only use letters, numbers, periods, spaces, hyphens,
                        brackets, ampersands, apostophes, parentheses slash(/), pound sign(#)
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card card-body bg-light mt-3">
                <div class="card-header bg-primary text-white">
                  Add Co-Owner's Signature
                </div>
                <br />
                <div class="row mb-3">
                  <div class="col-md-12">
                    <div class="row">
                      <div class="col-md-12">
                        <div class="form-group">
                          <label class="titleBold" for="coOwnerSignature">
                            Co-Owner's Signature
                          </label>
                          <input type="text" class="form-control" formControlName="coOwnerSignature" autocomplete="no" trim="blur"
                                 [ngClass]="{ 'is-invalid': j.coOwnerSignature.errors }" />
                          <div *ngIf="j.coOwnerSignature.errors" class="invalid-feedback">
                            <div *ngIf="j.coOwnerSignature.errors.required">This field is required</div>
                            <div *ngIf="j.coOwnerSignature.errors.maxlength">This field cannot be more than 50 characters</div>
                            <div *ngIf="j.coOwnerSignature.errors.minlength">This field cannot be less than 2 characters</div>
                            <div *ngIf="j.coOwnerSignature.errors.pattern">
                              Only use letters, numbers, periods, spaces, hyphens, brackets, ampersands, apostophes, parentheses slash(/), pound sign(#)
                            </div>
                          </div>
                          <div *ngIf="showMessage" class="invalid-feedback d-block">
                            You forgot to click the Add button to save your entry. Please make sure you clicked the Add button and try again.
                          </div>

                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-6">
                        <button type="button" (click)="addCoOwnerSignatureData()" class="btn btn-success">Add Co-Owner's Signature</button>&nbsp;
                        <button type="button" (click)="clearCoOwnerSignatureData()" class="btn btn-danger btn-sm">Clear Co-Owner's Signature</button>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-12 table-responsive">
                    <table class="table" #listofFiles>
                      <thead>
                        <tr>
                          <th class="tableHeaderFormattedText">Co-Owner's Signature</th>
                          <th class="tableHeaderFormattedText">Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let sL of coOwnerSignatureList; let i = index">
                          <td class="hidden">{{i}}</td>
                          <td class="tableRowFormattedText">{{sL.CoOwnerSignature}}</td>
                          <td>
                            <button type="button" class="btn btn-danger"
                                    (click)="removecoOwnerSignaturesRow(i)">
                              Remove
                            </button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <br /><br />
              <b>Dates of Property Ownership:</b><br />
              <div class="row rowformat">

                <div class="col-md-6">
                  <div class="form-group">
                    <label for="propertyOwnerSignature"><b>Property Acquisition Date:</b><span style="color:red" class="required"> *</span></label>
                    {{ stepThreeForm.get('dateTitleAcquired')?.value }}
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="propertyOwnerSignature"><b>Property Transfer of Ownership Date:</b><span style="color:red" class="required"> *</span></label>
                    {{ stepThreeForm.get('datePropertyWasSoldOrTransferred')?.value }}
                  </div>
                </div>
              </div>
              <br /><br />
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <label class="labelBoldWeight" for="signingOnBehalfQuestion"><b>Are you signing on behalf of an entity, trust, or estate (i.e., you are not the individual property owner)?:</b><span style="color:red" class="required"> *</span></label>
                    <select class="form-control" formControlName="signingOnBehalfQuestion" (change)="getAgentValue($event)" [ngClass]="{ 'is-invalid': j.signingOnBehalfQuestion.errors }">
                      <option value="">Please select an option</option>
                      <option value="Yes">Yes</option>
                      <option value="No">No</option>
                    </select>
                    <div *ngIf="j.signingOnBehalfQuestion.errors" class="invalid-feedback">
                      <div *ngIf="j.signingOnBehalfQuestion.errors.required">This field is required</div>
                    </div>
                  </div>
                </div>
              </div>
              <div *ngIf="showDivAgent == true">
                <div class="row">
                  <div class="col-md-12">
                    If you are signing on behalf of an entity, trust, or estate (i.e., you are not the individual property owner), please also complete the following:
                    I certify under penalty of perjury that (1) I am an authorized officer, partner, trustee, executor, guardian, or other legal representative of the Property Owner/Claimant; and (2) I am authorized to sign this Claim and Release Form on behalf of the Property Owner/Claimant.

                  </div>
                </div>
                <div class="row rowformat">
                  <div class="col-md-12">
                    <div class="form-group">
                      <label for="nameOfPersonSigning"><b>Name of Person Signing:</b><span style="color:red" class="required"> *</span></label>
                      <input type="text" class="form-control" id="nameOfPersonSigning" formControlName="nameOfPersonSigning" autocomplete="no"
                             trim="blur" [ngClass]="{ 'is-invalid': j.nameOfPersonSigning.errors }" />
                      <div *ngIf="j.nameOfPersonSigning.errors" class="invalid-feedback">
                        <div *ngIf="j.nameOfPersonSigning.errors.maxlength">This field must not be greater than 50 characters</div>
                        <div *ngIf="j.nameOfPersonSigning.errors.minlength">This field must be at least 2 characters</div>
                        <div *ngIf="j.nameOfPersonSigning.errors.pattern">
                          Only use letters, numbers, periods, spaces, hyphens,
                          brackets, ampersands, apostophes, parentheses slash(/), pound sign(#)
                        </div>
                        <div *ngIf="j.nameOfPersonSigning.errors.required">
                          The Name of Person Signing Field is Required
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row rowformat">
                  <div class="col-md-12">
                    <div class="form-group">
                      <label for="helperCapacity"><b>Capacity (e.g., Trustee, Executor, Officer): </b><span style="color:red" class="required"> *</span></label>
                      <input type="text" class="form-control" id="helperCapacity" formControlName="helperCapacity" autocomplete="no"
                             trim="blur" [ngClass]="{ 'is-invalid': j.helperCapacity.errors }" />
                      <div *ngIf="j.helperCapacity.errors" class="invalid-feedback">
                        <div *ngIf="j.helperCapacity.errors.maxlength">This field must not be greater than 50 characters</div>
                        <div *ngIf="j.helperCapacity.errors.minlength">This field must be at least 2 characters</div>
                        <div *ngIf="j.helperCapacity.errors.pattern">
                          Only use letters, numbers, periods, spaces, hyphens,
                          brackets, ampersands, apostophes, parentheses slash(/), pound sign(#)
                        </div>
                        <div *ngIf="j.helperCapacity.errors.required">
                          The Capacity Field is Required
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row rowformat">
                  <div class="col-md-12">
                    <div class="form-group">
                      <label for="signature"><b>Signature:</b><span style="color:red" class="required"> *</span></label>
                      <input type="text" class="form-control" id="signature" formControlName="signature" autocomplete="no"
                             trim="blur" [ngClass]="{ 'is-invalid': j.signature.errors }" />
                      <div *ngIf="j.signature.errors" class="invalid-feedback">
                        <div *ngIf="j.signature.errors.maxlength">This field must not be greater than 50 characters</div>
                        <div *ngIf="j.signature.errors.minlength">This field must be at least 2 characters</div>
                        <div *ngIf="j.signature.errors.pattern">
                          Only use letters, numbers, periods, spaces, hyphens,
                          brackets, ampersands, apostophes, parentheses slash(/), pound sign(#)
                        </div>
                        <div *ngIf="j.signature.errors.required">
                          The Signature Field is Required
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
                <div class="row">
                  <div class="col-md-4">
                    <div class="form-group">
                      <label class="labelBoldWeight" for="uniqueId"></label>
                      <input type="text" class="form-control" formControlName="uniqueId" autocomplete="no" trim="blur" [ngClass]="{ 'is-invalid': e.uniqueId.errors }" hidden />
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group">
                      <label class="labelBoldWeight" for="pin"></label>
                      <input type="text" class="form-control" formControlName="pin" autocomplete="no" trim="blur" [ngClass]="{ 'is-invalid': e.pin.errors }" hidden />
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group">
                      <label class="labelBoldWeight" for="noticeId"></label>
                      <input type="text" class="form-control" formControlName="noticeId" autocomplete="no" trim="blur" [ngClass]="{ 'is-invalid': e.noticeId.errors }" hidden />
                    </div>
                  </div>
                </div>
                <br />
                <div class="row">
                  <div class="col-md-12">
                    <div class="form-group">
                      <re-captcha formControlName="googleRecaptchaToken" (resolved)="resolved($event)" [ngClass]="{ 'is-invalid': submitted && j.googleRecaptchaToken.errors }"></re-captcha>
                      <div *ngIf="submitted && j.googleRecaptchaToken.errors" class="invalid-feedback">
                        <div *ngIf="j.googleRecaptchaToken.errors.required" style="color:red; font-size:80%">This field is required</div>
                      </div>
                      <!--<div style="color:#dc3545; font-size:80%; font-weight:bold">This field is required*</div>-->

                    </div>
                  </div>
                </div>
                <br />
                <br /><br />
                <div class="row">
                  <div class="col-md-12 text-center">
                    <div *ngIf="showDivSubmittalErrorMessage == true" class="submittal-custom-error" style="color:red">
                      Submission failed, please review your entries for errors.
                    </div>
                  </div>
                </div>
                <br /><br />
                <ul class="list-inline float-right">
                  <li>
                    <button class="btn btn-primary" matStepperPrevious>Back</button>&nbsp;
                    <button class="btn btn-primary" [disabled]="submitClicked" (click)="onSubmit()" type="submit">Submit</button>
                  </li>
                </ul>
                <br /><br />
              </div>
            </div>
        </div>
      </div>

    </form>
    <ngx-spinner bdColor="rgba(51,51,51,0.8)"
                 size="medium"
                 color="#fff"
                 type="ball-scale-multiple">
      <p style="font-size: 20px; color: white">Saving Data...</p>
    </ngx-spinner>
  </mat-step>

</mat-horizontal-stepper>

